import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { HorizontalLayout } from 'widgets/Layout';

import { RadioCircle, RadioInput, RadioLabel, RadioOption } from './RadioCommons';

interface FormRadioButtonProps {
    name: string;
    disabled?: boolean;
    value: string | number;
    label: string;
    variant?: 'default' | 'outline';
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const FormRadioButton = ({
    name,
    disabled = false,
    value,
    label,
    variant = 'default',
    onChange,
}: FormRadioButtonProps) => {
    const { register, watch } = useFormContext();
    const radioValue = watch(name);
    const { onChange: rhfOnChange, ...registerProperties } = register(name);

    const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        rhfOnChange(e);
        if (onChange) {
            onChange(e);
        }
    };

    const id = `${name}-${value}-${Date.now()}`;

    if (variant === 'outline') {
        return (
            <RadioOption htmlFor={id}>
                <RadioOutlineLayout $apart>
                    <RadioLabel>{label}</RadioLabel>
                    <RadioInput
                        {...registerProperties}
                        type="radio"
                        value={value}
                        id={id}
                        disabled={disabled}
                        onChange={handleOnChange}
                    />
                    <RadioCircle $checked={radioValue === value} />
                </RadioOutlineLayout>
            </RadioOption>
        );
    }
    return (
        <RadioOption htmlFor={id}>
            <RadioInput
                {...registerProperties}
                type="radio"
                value={value}
                id={id}
                disabled={disabled}
                onChange={handleOnChange}
            />
            <RadioCircle $checked={radioValue === value} />
            <RadioLabel>{label}</RadioLabel>
        </RadioOption>
    );
};

const RadioOutlineLayout = styled(HorizontalLayout)`
    width: 100%;
    padding: 10px 4px 10px 12px;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.colors.cocoa200};
`;
